import React, { useRef } from 'react';

const FeedComponent = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const textRef = useRef<HTMLDivElement | null>(null);
	const imageRef = useRef<HTMLImageElement | null>(null);
	const bg1Ref = useRef<HTMLDivElement | null>(null);
	const bg2Ref = useRef<HTMLDivElement | null>(null);
	
	return (
		<div className="feedComponent projectsPanel" ref={containerRef} id="testComp__content_data_item_id_3">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="feedComponent__content">
				<div
					className="feedComponent__content_data"
					ref={textRef}
				>
					<h2>Stay tuned</h2>
					<span>Our team keeps track of all updates on the projects and publishes important ones on the platform so that you are stay up to date and don't miss anything important.</span>
				</div>
				<div
					className="feedComponent__content_image"
					ref={imageRef}
				>
					<div
						className="feedComponent__content_image_background_1"
						ref={bg1Ref}
					></div>
					<div
						className="feedComponent__content_image_background_2"
						ref={bg2Ref}
					></div>
					<img src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/feed/MainImage.webp`} alt="Main"/>
				</div>
			</div>
		</div>
	);
};

export default FeedComponent;